<template>
  <v-app>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import { getUserRoles } from "./store/modules/user";

export default {
  name: "App",
  data: () => ({
    //
  }),
  created() {
    getUserRoles();
  },
  watch: {
    $route(to, from) {
      if (to.path != from.path) {
        getUserRoles();
      }
    },
  },
};
</script>
